export function isEscapeKey(ev) {
  if (!ev) {
    return false;
  }

  return ev.key === 'Escape' || ev.key === 'Esc' || ev.keyCode === 27;
}
export function isEnterKey(ev) {
  if (!ev) {
    return false;
  }

  return ev.code === 'Enter' || ev.key === 'Enter' || ev.keyCode === 13;
}

export function lockWindow() {
  document.documentElement.style.overflow = 'hidden';
}

export function unlockWindow() {
  document.documentElement.style.overflow = '';
}

export function getQueryParam(param, sanitize = true) {
  const url = new URL(window.location.href);
  const params = Object.fromEntries(url.searchParams.entries());
  let rawParam = params[param];

  if (rawParam && sanitize) {
    rawParam = window.decodeURI(rawParam).replace('%23', '#');
  }
  return rawParam;
}